module.exports = __webpack_public_path__ + "static/09afc94a090feff7853fa7b0d73865978c7e37dcb259ef8ebef7fb7b1e3bd3c2-8f6782acf169e88f42e4c3c6a35e7c5a.png";